import React from 'react';
import { connect, ConnectedComponent } from 'react-redux';

import { bindActionCreators } from 'redux';
import { sendPageAnalytics, SendPageAnalytics } from './redux/actions';

type Props = {
  sendPageAnalytics: SendPageAnalytics;
};

const analytics = (
  ComponentToWrap,
  page: string
): ConnectedComponent<any, any> => {
  class AnalyticsComponent extends React.Component<Props, {}> {
    componentDidMount() {
      this.props.sendPageAnalytics({
        page,
      });
    }

    render() {
      return <ComponentToWrap {...this.props} />;
    }
  }
  const mapDispatchToProps = dispatch =>
    bindActionCreators(
      {
        sendPageAnalytics,
      },
      dispatch
    );

  return connect(null, mapDispatchToProps)(AnalyticsComponent);
};

export default analytics;
